module.exports = __webpack_public_path__ + "img/logo_topo.0a950f88.jpeg";